import { calculateSizeFromStepValues } from './size-calculator';
import { Size } from '../enums/size.enum';
import { StepValues } from '../models/step-values';
import { ProductHandle } from '../../enums/ProductHandle.enum';

const engineVariableRegex = /.*{(.+)}.*/g;
export const parseEngineVariables = (
  text: string | undefined,
  stepValues: StepValues,
  productHandle: ProductHandle | undefined,
  withModifiers = true,
): string => {
  if (!text) {
    return '';
  }

  const size = calculateSizeFromStepValues(stepValues, productHandle, withModifiers);
  // console.log('Size', text, size, Size[size]);

  if (text.indexOf('[engine]') !== -1) {
    return text.replace('[engine]', Size[size]);
  }

  if (text.indexOf('[engine-1]') !== -1) {
    const newSize = Size[size - 1];

    if (newSize && size - 1 > 0) {
      return text.replace('[engine-1]', newSize);
    } else {
      return 'XS is currently our smallest size';
    }
  }

  if (text.indexOf('[engine+1]') !== -1) {
    const newSize = Size[size + 1];
    if (newSize) {
      return text.replace('[engine+1]', newSize);
    } else {
      return '3X is currently our largest size';
    }
  }

  if (text.indexOf('{') === -1 || text.indexOf('}') === -1) {
    return text;
  }

  // Reset Regex
  engineVariableRegex.exec('');

  const originalText = text;
  const match = engineVariableRegex.exec(originalText);
  if (match) {
    // TODO legacy: For now we are only handling a single variable match
    //       Later we may need to add support for multiple
    const variable = match[1];

    if (variable.indexOf('+') > -1) {
      const key = variable.substring(0, variable.indexOf('+')).trim();
      const step = stepValues.get(key);
      if (!step || !step.text) {
        return originalText.replace(`{${variable}}`, '[Missing Data]');
      }
      const value = parseInt(step.text, 10);
      const alteration = parseInt(variable.substring(variable.indexOf('+') + 1).trim(), 10);
      const result = value + alteration;
      return originalText.replace(`{${variable}}`, '' + result);
    } else if (variable.indexOf('-') > -1) {
      const key = variable.substring(0, variable.indexOf('-')).trim();
      const step = stepValues.get(key);
      if (!step || !step.text) {
        return originalText.replace(`{${variable}}`, '[Missing Data]');
      }
      const value = parseInt(step.text, 10);
      const alteration = parseInt(variable.substring(variable.indexOf('-') + 1).trim(), 10);
      const result = value - alteration;
      return originalText.replace(`{${variable}}`, '' + result);
    } else {
      const key = variable.trim();
      const value = stepValues.get(key);
      if (value && value.text) {
        return originalText.replace(`{${variable}}`, value.text);
      }

      return originalText.replace(`{${variable}}`, '[Missing Data]');
    }
  }

  return originalText;
};
